import { createApp } from "vue";
import App from "./App.vue";
import i18n from "./language/i18n";
// import store from "./store";
import axios from "@/js/axios.js";
import VueAxios from "vue-axios";
//import VueAxios from "vue-axios";
import Loading from "vue-loading-overlay";
import { createPinia } from 'pinia'
import "vue-loading-overlay/dist/css/index.css";
import "../node_modules/bootstrap/scss/bootstrap.scss";
import "./assets/scss/main.scss";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";
import VueSweetalert2 from "vue-sweetalert2";
const pinia = createPinia();
createApp(App)
.component("Loading", Loading)
// .use(store)
.use(VueAxios, axios)
.use(i18n)
.use(pinia)
.use(VueSweetalert2)
.mount("#app");
const app = createApp(App);
app.config.devtools = true;
